import React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

import Text from '../Text';
import { useStyles } from '~/hooks';
import { FONT_SIZE_XS } from '~/constants';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';

type Props = {
    style?: StyleProp<ViewStyle>;
};

export default function AIBadge({ style }: Props) {
    const styles = useStyles(stylesGenerator);

    return (
        <View style={[styles.container, style]}>
            <Text fontType="LATO_BLACK" style={styles.label} noTranslate={true}>
                AI
            </Text>
        </View>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        container: {
            marginTop: scaleSize(3),
            borderRadius: scaleSize(2),
            width: scaleSize(18),
            height: scaleSize(13),
            backgroundColor: theme.aiInfo,
            justifyContent: 'center',
            alignItems: 'center',
        },
        label: { fontSize: FONT_SIZE_XS, color: theme.aiTextColor },
    });
